import React, { useMemo } from 'react';
import { Input, InputAdornment, InputNumber, Select } from 'tdesign-react';
import { isValidJSON, isVoid, toTsOptions } from '@/utils/common';
import Text from '@/components/Text';
import TextSelect from '@/components/TextSelect';

// showDetail转props
export const convertDetailToProps = (showDetail) => {
  return isValidJSON(showDetail) ? JSON.parse(showDetail || null) : null;
};

/**
 * @typedef {Object} Props
 * @prop {1|2|3} type 1输入框 2下拉 3数字框
 * @prop {Object} inputProps 输入框参数
 */

/**
 * 动态输入框，根据变量输入定义
 * @param {Props} props
 * @returns
 */
export default function VarInput({ type, inputProps, readOnly, ...others }) {
  const { prepend, append, options: _options, min, max, decimalPlaces, suffix } = inputProps || {};

  // 保证有label
  const options = useMemo(() => {
    return _options?.map((item) => ({ label: item.label || item.value, value: item.value }));
  }, [_options]);

  switch (type) {
    case 1: {
      const emptyPrepend = isVoid(prepend);
      const emptyAppend = isVoid(append);
      let input = <Input {...others} />;
      if (readOnly) input = <Text {...others} />;
      if (emptyPrepend && emptyAppend) {
        if (readOnly) return <Text {...others} />;
        return input;
      }
      return (
        <InputAdornment
          style={{ width: '100%' }}
          prepend={emptyPrepend ? null : prepend}
          append={emptyAppend ? null : append}
        >
          {input}
        </InputAdornment>
      );
    }

    case 2:
      return readOnly ? (
        <TextSelect options={options} {...others} />
      ) : (
        <Select options={toTsOptions(options)} {...others} />
      );

    case 3:
      return readOnly ? (
        <Text {...others} value={`${others.value || ''}${suffix || ''}`} />
      ) : (
        <InputNumber
          min={min}
          max={max}
          suffix={suffix}
          decimalPlaces={decimalPlaces}
          allowInputOverLimit={false}
          theme='normal'
          {...others}
        />
      );
    default:
      return null;
  }
}
